import type React from 'react';
import { FinancialPositionPageView } from './FinancialPositionPageView';

/**
 * `/analytics/financial-position` — the Analytics shell's default tab.
 *
 * A pure composition: the rail, the notices and the four self-served metric
 * cards, each of which owns its own read, its own `ErrorBoundary` and its own
 * empty state.
 *
 * There is no hook here any more (BOS-170). It existed to hold two CTA stubs
 * for a pair of PromptCards that duplicated two of the metric cards below;
 * those cards are gone, and the actions they promised belong to the live cards
 * that can actually offer them.
 */
export const FinancialPositionPage: React.FC = () => (
    <FinancialPositionPageView />
);
